import { useCallback, useMemo, useState } from 'react';

export interface LocationSuggestion {
  description: string;
  placeId?: string;
  index?: number;
}

export interface UseLocationSearchResult {
  value: string;
  suggestion: LocationSuggestion | null;
  dropdownHidden: boolean;
  setDropdownHidden(hidden: boolean): void;
  onChange(value: string): void;
  onSelect(s: LocationSuggestion): void;
}

export function useLocationSearch(initialValue: string = ''): UseLocationSearchResult {
  const [value, setValue] = useState<string>(initialValue);
  const [suggestion, setSuggestion] = useState<LocationSuggestion | null>(null);
  const [dropdownHidden, setDropdownHidden] = useState<boolean>(true);

  const onChange = useCallback((next: string) => {
    setValue(next);
    setDropdownHidden(next === '');
  }, []);

  const onSelect = useCallback((s: LocationSuggestion) => {
    const text = s?.description || '';
    setValue(text);
    setSuggestion(s);
    setDropdownHidden(true);
  }, []);

  return useMemo(
    () => ({ value, suggestion, dropdownHidden, setDropdownHidden, onChange, onSelect }),
    [dropdownHidden, onChange, onSelect, suggestion, value]
  );
}
